import {XauditModel} from '../xaudit.model';

export class PatientCaseEndoFinalReportRestorRecomdDataModel extends XauditModel {
  CaseFinalReportRestorRecomendID: string;
  CaseFinalReportID: string;
  enumFinalReportRestorationMethodID: string;
  OtherInText: string = '';
}
